import { render } from "./SpacingPage.vue?vue&type=template&id=56ddd11e&ts=true"
import script from "./SpacingPage.vue?vue&type=script&lang=ts"
export * from "./SpacingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__